<template>
	<div class="DetailedFloorArea">
		<div v-if="!visible">
			<h3 class="popup-tilte">Helyiségek száma</h3>
            <div class="floor-areas-subtitle">Kérjük, hogy az alábbiakban csak a helyiségek számát adja meg, a helyiségek területét a Tovább gomb megnyomása után megjelenő ablakban kell kitölteni!</div>
			<table class="FloorAreaLists">
				<tr>
					<th>Megnevezés</th>
					<th>Mennyiség</th>
				</tr>
				<tr v-for="(premiseType, index) in getPremiseTypes" :key="index">
					<td>{{ premiseType.name }}</td>
					<td>
						<span class="qty-wrapper">
							<button type="button" value="-" class="minus" @click="minus(premiseType)"></button>
							<input
								type="number"
								step="1"
								min="0"
								max=""
								name="quantity"
								:value="getPremiseCount(premiseType.id)"
								title="Qty"
								class="input-text qty text"
								size="4"
								pattern=""
								inputmode=""
								data-hj-allow
							/>
							<button type="button" value="+" class="plus" @click="plus(premiseType)"></button>
						</span>
					</td>
				</tr>
			</table>

			<div class="con-1334 navBtn mt-30px">
                <a class="navBtn-prev" @click="clearAndClose()">Mégse</a>
				<a class="navBtn-next btn btn-blue" @click="step()">Tovább</a>
			</div>
		</div>
		<div v-if="visible">
			<h3 class="popup-tilte">Részletes alapterület</h3>
            <div class="floor-areas-subtitle">Kérjük, adja meg az egyes helyiségek alapterületét!</div>
			<ValidationObserver ref="form" v-slot="{ invalid }" slim>
				<table class="FloorAreaInput form">
					<tr v-for="(premise, index) in getPremises" :key="index">
						<td class="mw-250px w-50">{{ premise.label }}</td>
						<td style="width: 50%">
							<CalcElem
								name="floor_area"
								:index="index"
								:options="{
									inputGroup: 'premises',
									type: 'text',
									unit: 'm2',
									rules: 'required|number_space',
									wrapperClass: '',
									className: '',
									label: `${index + 1}. Alapterület`,
									inputmode: 'numeric',
									format: true,
								}"
							/>
						</td>
					</tr>
					<tr class="sum">
						<td>Összesen:</td>
						<td>
							<span>{{ getPremiseSum | formatNumber }}</span>
							m2
						</td>
					</tr>
				</table>

				<div class="con-1334 navBtn">
					<a class="navBtn-prev" @click="step()">Vissza</a>
					<a class="navBtn-next btn btn-blue" @click="fill()" :disabled="invalid">Tovább</a>
				</div>
			</ValidationObserver>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import _ from 'lodash';

export default {
	async mounted() {
		await this.fetchPremiseTypes();
        await this.fixPremises();
	},
	data() {
		return {
			visible: false,
			getField: [],
			qty: 0,
		};
	},
	computed: {
		...mapGetters(['getPremiseTypes', 'getPremiseCount', 'getPremises', 'getPremiseSum']),
	},
	methods: {
		...mapActions(['fetchPremiseTypes']),
		...mapMutations(['newPremise', 'deletePremise', 'showPopup', 'setInputData','popupHasClose','clearPremises','fixPremises']),
		step() {
			this.visible = !this.visible;
		},
		next() {
			this.visible = false;
		},
		minus(premiseType) {
			this.deletePremise(premiseType.id);
		},
		plus(premiseType) {
			this.newPremise({
				type_id: premiseType.id,
				label: premiseType.name,
				floor_area: null,
				multipler: premiseType.multipler,
			});
		},
		fill() {
			this.$refs.form.validate().then(success => {
				if (success) {
					this.setInputData({
						group: 'real_estate',
						key: 'floor_area',
						value: this.getPremiseSum,
						index: null,
					});
                    this.popupHasClose(false);
					this.showPopup(null);
				}
			});
		},
        clearAndClose() {
            this.clearPremises();
            this.popupHasClose(false);
            this.showPopup(null);
        },
	},
};
</script>
<style scoped>
.floor-areas-subtitle {
    max-width: 565px;
    margin-left: auto;
    margin-right: auto;
}
</style>
